package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.options.AngleLineOptions

@Suppress("unused")
@RadarDsl
class AngleLineScope {
    var display: Boolean = true
    private var color: JSScriptableIndexable<ChartColor>? = null
    private var lineWidth: JSScriptable<Float>? = null
    private var borderDash: JSScriptable<List<Int>>? = null
    private var borderDashOffset: JSScriptable<Float>? = null

    fun color(value: ChartColor) { color = JSScriptableIndexable.Static(value) }
    fun color(values: List<ChartColor>) { color = JSScriptableIndexable.PerPoint(values) }
    fun color(fn: (dynamic) -> ChartColor) { color = JSScriptableIndexable.Scriptable(fn) }

    fun lineWidth(value: Float) { lineWidth = JSScriptable.Static(value) }
    fun lineWidth(fn: (dynamic) -> Float) { lineWidth = JSScriptable.Scriptable(fn) }

    fun borderDash(value: List<Int>) { borderDash = JSScriptable.Static(value) }
    fun borderDash(fn: (dynamic) -> List<Int>) { borderDash = JSScriptable.Scriptable(fn) }

    fun borderDashOffset(value: Float) { borderDashOffset = JSScriptable.Static(value) }
    fun borderDashOffset(fn: (dynamic) -> Float) { borderDashOffset = JSScriptable.Scriptable(fn) }

    internal fun build() = AngleLineOptions(
        display = display,
        color = color,
        lineWidth = lineWidth,
        borderDash = borderDash,
        borderDashOffset = borderDashOffset,
    )
}
